"use client";

import React from "react";
import "./OurStory.scss";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import { slideFromLeft, slideFromRight, defaultViewport } from "@/utils/animations";
import { strapiImageUnoptimized } from "@/lib/strapi/strapiImage";

export type OurStoryStrapiPayload = {
  description: string;
  firstImage: string;
  secondImage: string;
  thirdImage: string;
};

type OurStoryClientProps = {
  strapi: OurStoryStrapiPayload;
};

export default function OurStoryClient({ strapi }: OurStoryClientProps) {
  const router = useRouter();
  const isMobile = useMediaQuery("(max-width:1023px)");

  return (
    <div className="home-ourstory-wrapper baseContainer">
      <div className="maxWidth">
        <motion.div
          className="left"
          variants={slideFromLeft}
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
        >
          <p className="section-main-header black">Our Story</p>
          <p className="text-medium-24 grey-700 ">{strapi.description.trim()}</p>

          {!isMobile && (
            <button className="main-btn light-blue" onClick={() => router.push("/about")}>
              Continue Reading
            </button>
          )}
        </motion.div>

        <motion.div
          className="right"
          variants={slideFromRight}
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
        >
          <Image
            src={strapi.firstImage}
            width={960}
            height={640}
            alt="Amherst Supply team working"
            unoptimized={strapiImageUnoptimized(strapi.firstImage)}
            className="h-auto w-full max-w-full object-contain"
          />

          <div className="images-container">
            <Image
              src={strapi.secondImage}
              width={640}
              height={480}
              alt="Amherst Supply storefront"
              unoptimized={strapiImageUnoptimized(strapi.secondImage)}
              className="h-auto w-full max-w-full object-contain"
            />
            <Image
              src={strapi.thirdImage}
              width={640}
              height={480}
              alt="Amherst Supply delivery truck"
              unoptimized={strapiImageUnoptimized(strapi.thirdImage)}
              className="h-auto w-full max-w-full object-contain"
            />
          </div>
        </motion.div>

        {isMobile && (
          <button className="main-btn light-blue" onClick={() => router.push("/about")}>
            Continue Reading
          </button>
        )}
      </div>
    </div>
  );
}
